export default "__VITE_ASSET__Cu84F3H6__"